import Modal from '../../../common/modal'
import Button from '@mui/material/Button'
import { Stack, Box, Typography, Radio } from '@mui/material'
import { Modal as MuiModal } from '@mui/material'
import { useMemo, useRef, useState } from 'react'
import QRCode from 'react-qr-code'
import { useEffect } from 'react'
import LineInputV2 from '../../../../../src/components/common/lineinputV2'
import { clickElement, focusElemnt, getInt, getNum, navigation1, navigation2, singleInputKeyDown } from '../../../common/helper'
import { connect } from 'react-redux'
import { Item } from '../../../common/snippets'
import {
  SaveDebitCreditNote,
  getBranchConfigOrEwbillinfo,
  getPartyList,
  updateModal,
  updateAlert,
} from '../../../../store/common/common_action'
import DropDownOA from '../../../common/dropDownOA'
import LineInput from '../../../common/lineinput'
import Datepicker from '../../../common/datePicker'
import * as mdt from '../../../../components/common/modaltypes'
import moment from 'moment'
import * as id from '../../../common/bookingElementId'
import { useTranslation } from '../../../../i18n/I18nProvider'

const BranchCreditDebitNote = (props) => {
  const { translations } = useTranslation()
  const rdcn = translations?.rechargeDebitCreditNote || {}
  const cs = translations?.common || {}
  const {
    data: { common },
    getBranchConfigOrEwbillinfo,
    getPartyList,
    updateModal,
    updateAlert,
    SaveDebitCreditNote,
  } = props
  const { loginData, citywiseBranchList, partyList } = common
  const [selectedRadioPopup, setSelectedRadioPopup] = useState('debit')
  const [resetBranch, setResetBranch] = useState(false)
  const [resetParty, setResetParty] = useState(false)
  const [focusOnBranchList, setFocusOnBranchList] = useState(true)
  const [focusOnPartyList, setFocusOnPartyList] = useState(true)
  // const [data, setData] = useState({
  //   branchId: 0,
  //   partyID: 0,
  //   date: moment(new Date()),
  //   amount: 0,
  //   remark: '',
  // })
  const [branch, setBranch] = useState(0)
  const [party, setParty] = useState(0)
  const [amount, setAmount] = useState(0)
  const [remark, setRemark] = useState('')
  const [transactionDate, setTransactionDate] = useState(moment(new Date()))
  const buttonRef1 = useRef(null)
  const buttonRef2 = useRef(null)
  const filteredBranchList = useMemo(() => {
    return (citywiseBranchList || []).filter(branch => branch.IsCargoCreditLimit === 1);
  }, [citywiseBranchList]);
  useEffect(() => {
    const obj = {
      intUserID: 0,
      intCompanyID: loginData.intCompanyID,
      intBranchID: 0,
      strBranchName: '',
      strBranchCode: '',
      intStateID: 0,
      intCityID: 0,
      intIsActive: 1,
    }
    getBranchConfigOrEwbillinfo(obj, true, 24 * 60 * 60 * 1000) //branchList api
    const obj1 = {
      intPartyID: 0,
      intCompanyID: loginData.intCompanyID,
      strPartyName: '',
      strContactPerson: '',
      intCityID: 0,
      intIsCreditParty: -1,
      intIsActive: -1,
      intIsDeleted: 0,
    }
    getPartyList(obj1, false, true, 24 * 60 * 60 * 1000) //PartyList api
  }, [])
  const handleChangeRadio = (e) => {
    setSelectedRadioPopup(e.target.value)
    if (props?.selectedRadio === 'branch') {
      focusElemnt(id.BranchList)
      setResetBranch(true)
    } else {
      focusElemnt(id.PartyList)
      setResetParty(true)
    }
  }
  const handleAlert = (msg = false) => {
    if (!(msg instanceof Event)) {
      if (msg) {
        updateAlert({ show: true, msg })
      } else {
        updateAlert({ show: false, msg: '' })
      }
    }
  }
  const handleSave = () => {
    if (amount > 0) {
      const newDate = transactionDate
      const finalDate = newDate.format('YYYY-MM-DD')
      const obj = {
        CompanyID: loginData.intCompanyID,
        UserID: loginData.intUserID,
        TranType: selectedRadioPopup === 'debit' ? 'dr' : 'cr',
        BranchID: branch,
        TranDate: finalDate,
        Amount: amount,
        Remarks: remark,
        PartyID: party,
      }
      SaveDebitCreditNote(obj)
      props.updateModal(false, mdt.branchCreditDebitNote)
      props.handleChange('recharge')
    } else {
      handleAlert(rdcn.amountShouldBeGreaterThanZero || 'Amount should be Gratter than 0!')
    }
  }

  function subtractDaysFromDate(date, days) {
    const formattedDate = moment(date, 'YYYY-MM-DD').subtract(days, 'days').format('YYYY-MM-DD')
    return formattedDate
  }
  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
  }
  return (
    <Modal
      headTxt={props.selectedRadio === 'branch' ? rdcn.debitCreditNoteForBranch || 'Debit/Credit Note For Branch' : rdcn.debitCreditNoteForParty || 'Debit/Credit Note For Party'}
      width={'30%'}
      updateModal={(e) => {
        updateModal()
        props.handleChange('recharge')
      }}
    >
      <Stack>
        <Box className="light-bg radio-wrap" sx={{ display: 'flex' }}>
          <label htmlFor={'isCrossingRadioYes'} className="radio-label flex">
            <Radio
              id={'isCrossingRadioYes'}
              name={`isCrossingRadio`}
              size={'medium'}
              value="debit"
              checked={selectedRadioPopup === 'debit'}
              onChange={(e) => {
                handleChangeRadio(e)
              }}
            />
            <span style={{ marginTop: '10px' }}>{rdcn.debitNote || 'Debit Note'}</span>
          </label>
          <label htmlFor={'isCrossingRadioNo'} className="radio-label flex">
            <Radio
              id={'isCrossingRadioNo'}
              name={`isCrossingRadio`}
              size={'medium'}
              value="credit"
              checked={selectedRadioPopup === 'credit'}
              onChange={(e) => {
                handleChangeRadio(e)
              }}
            />
            <span style={{ marginTop: '10px' }}>{rdcn.creditNote || 'Credit Note'}</span>
          </label>
        </Box>
      </Stack>
      {props.selectedRadio === 'branch' ? (
        <Item>
          <DropDownOA
            id={id.BranchList}
            data={filteredBranchList || []}
            // data={citywiseBranchList || []}
            width="100%"
            label={rdcn.selectBranch || 'Select Branch'}
            searchPlaceholder={rdcn.searchByBranch || 'Search By Branch'}
            isObjArr={true}
            dataKey={`BranchName`}
            idKey={`BranchID`}
            tabIndex="5"
            autoFocus={focusOnBranchList}
            resetFlag={resetBranch}
            onSelect={(e) => {
              // setData({ ...data, branchId: e.BranchID })
              setBranch(e.BranchID)
              setFocusOnBranchList(false)
              setResetBranch(false)
            }}
            nextId={id.TransactionDate}
          />
        </Item>
      ) : (
        <Item>
          <DropDownOA
            id={id.PartyList}
            data={partyList || []}
            width="100%"
            label={rdcn.selectParty || 'Select Party'}
            searchPlaceholder={rdcn.searchByParty || 'Search By Party'}
            isObjArr={true}
            autoFocus={focusOnPartyList}
            dataKey={`Party`}
            idKey={`PartyID`}
            tabIndex="5"
            resetFlag={resetParty}
            onSelect={(e) => {
              // setData({ ...data, partyID: e.PartyID })
              setParty(e.PartyID)
              setFocusOnPartyList(false)
              setResetParty(false)
            }}
            nextId={id.TransactionDate}
          />
        </Item>
      )}
      <Item className="input--container bookingDatePicker">
        <Datepicker
          id={id.TransactionDate}
          label={rdcn.transactionDate || 'Transaction Date'}
          //  date={data.date}
          dateChange={(date) => {
            // setData({ ...data, date: date })
            setTransactionDate(date)
            focusElemnt(id.Amount)
          }}
          startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
          endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 365)} //will return future 1 year date
        />
      </Item>
      <Item>
        <div className={'input--wrapper'} style={{ marginBottom: '0px' }}>
          <LineInputV2
            id={id.Amount}
            className="input-lable"
            type="number"
            label={cs.amount || 'Amount'}
            value={amount}
            onBlur={(e) => {
              setAmount(e.target.value)
              //  setData({ ...data, amount: e.target.value })
            }}
            onKeyDown={(e) => navigation2(e, id.Remark, id.TransactionDate)}
          />
        </div>
      </Item>
      <Item>
        <div className={'input--wrapper'}>
          <LineInputV2
            id={id.Remark}
            className="input-lable"
            type="text"
            label={rdcn.remark || 'Remark'}
            value={remark}
            onBlur={(e) => {
              setRemark(e.target.value)
              //setData({ ...data, remark: e.target.value })
            }}
            onKeyDown={(e) => navigation1(e, id.SaveCreditDebitButton, id.Amount)}
          />
        </div>
      </Item>
      <Stack>
        <Box>
          <div style={{ display: 'flex', textAlign: 'right', justifyContent: 'right', marginRight: '10px', marginBottom: '10px' }}>
            <Item sx={{ background: '#fff', border: '1px solid #f15a22', textAlign: 'center', margin: '10px', height: '42px' }}>
              <Button
                variant="outlined"
                sx={{ width: '10%', height: '-webkit-fill-available' }}
                style={{ borderColor: '#fff', color: '#f15a22', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                onClick={(e) => {
                  updateModal()
                  props.handleChange('recharge')
                }}
              >
                {cs.cancel || 'CANCEL'}
              </Button>
            </Item>
            <Item
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button
                id={id.SaveCreditDebitButton}
                variant="contained"
                className="btn btn-primary"
                onClick={() => {
                  handleSave()
                }}
                sx={{
                  width: '100%',
                  padding: '10px',
                  letterSpacing: '2px',
                  height: '40px',
                  marginLeft: '10px',
                }}
              >
                {cs.save || 'Save'}
              </Button>
            </Item>
          </div>
        </Box>
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlert, getBranchConfigOrEwbillinfo, getPartyList, SaveDebitCreditNote }
export default connect(mapStateToProps, mapDispatchToProps)(BranchCreditDebitNote)
